import React, { useState } from "react";
import { Row, Col, Form, Radio } from "antd";
import _ from "lodash";

interface MultiSelectRadioGroupInterface {
  activeQuestion?: any;
  suggestionsData?: any;
  handlePriceRangeChange?: any;
}

const MultiSelectRadioGroup: React.FC<MultiSelectRadioGroupInterface> = (
  props
) => {
  const { activeQuestion, suggestionsData, handlePriceRangeChange } = props;
  const [selectedRanges, setSelectedRanges] = useState({});
  const arr = _.union(suggestionsData?.basic, suggestionsData?.savvy);

  const handleSelection = (values: any, product: any) => {
    let ranges: any = { ...selectedRanges };
    ranges[product] = values;
    setSelectedRanges(ranges);
    handlePriceRangeChange(ranges);
  };

  return (
    <div className="input-checkbox-group">
      <div className="input-checkbox-group__row input-checkbox-group__row--sticky">
        <div className="input-checkbox-group__col input-checkbox-group__col--product">
          <div className="label label--product">Price Range</div>
        </div>
        <Row className="input-checkbox-group__col">
          {activeQuestion?.labels?.map((label: any, index: any) => {
            return (
              <Col span={4} key={index}>
                <div className="label label--options">{label}</div>
              </Col>
            );
          })}
        </Row>
      </div>
      {arr?.map((product: any, index: number) => {
        return (
          <div
            className="input-checkbox-group__row input-checkbox-group__wrapper"
            key={`${product}-${index}`}
          >
            <div className="input-checkbox-group__col input-checkbox-group__col--product">
              <div className="product-item">{product}</div>
            </div>
            <div className="input-checkbox-group__col">
              <Form.Item
                name={`priceRange-+-${product}`}
                rules={[
                  {
                    required: true,
                    message: "You have to choose atleast one option",
                  },
                ]}
              >
                <Radio.Group
                  style={{ width: "100%" }}
                  onChange={(e: any) => {
                    handleSelection(e?.target?.value, product);
                  }}
                >
                  <Row>
                    {activeQuestion?.labels?.map((option: any, index: any) => {
                      return (
                        <Col span={4} key={`${option}-${index}`}>
                          <Radio value={option}></Radio>
                        </Col>
                      );
                    })}
                  </Row>
                </Radio.Group>
              </Form.Item>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MultiSelectRadioGroup;
